export default "__VITE_ASSET__CjuUEwA8__"